import type { StaticTextResource } from '../keys'

export const zhCN: StaticTextResource = {
  'schedule.dueToday': '今天{{time}}截止',
  'schedule.dueTomorrow': '明天{{time}}截止',
  'schedule.durationRange':
    '{{start}} - {{end}} (第{{currentDay}}天 / {{days}}天)',
  'editReport.defaultPageName': '第{{n}}页',
  'editReport.defaultSectionName': '区块',
  'editReport.defaultRepeatSectionName': '重复区块',
}
